import { isInitialized, moduleLookupAsDefault, ltjsModule, getRegisteredModules, getRegisteredPortablePackages, initialize, typeMap, currentRuntimeIsLoaderRuntime, } from './ltjsEnvironment';
import * as RuntimeConfigurationModule from './runtime/RuntimeConfiguration';
import { loadScript, getRelativeAssetPath, loadNLSProperties } from './util/ltjsLoaderUtil';
import { getResourceURL, purge, getUriParameter, getFormatLocale, getLocale, warn, ajax, getImage, getSASAjaxConfig, getBrowserName, BROWSER, } from './ltjsUtil';
import ImageDataPolicy from './resources/images/ImageDataPolicy';
import DispatchBridge from './events/DispatchBridge';
import EventDispatcher from './events/EventDispatcher';
import Runtime from './runtime/Runtime';
import * as ResourceManagerModule from './resources/ResourceManager';
import * as StyleModule from './styles/Style';
import BuiltInStyles from './styles/BuiltInStyles';
import * as TraceUtil from './util/TraceUtil';
import BrowserFacility from './resources/localization/BrowserFacility';
//ltjs module imports.
import TextAlignment from './styles/TextAlignment';
import * as WrappableCloset from './WrappableCloset';
import HttpVerb from './resources/network/HttpVerb';
import * as NetworkDataEventModule from './resources/network/NetworkDataEvent';
import * as NetworkImageEventModule from './resources/images/NetworkImageEvent';
import RenderMode from './RenderMode';
import TextUtil from './util/TextUtil';
import * as ViewManagerModule from './ViewManager';
import * as PortableEventModule from './events/PortableEvent';
import TriState from './util/TriState';
//ltjsUtil imports.
import './resources/localization/LanguageTag';
import { updateVisualizationSizes } from './util/VisualizationUtil';
// Force the import of TiledImageLoader. This is needed by
// SASNetworkManagerImplementationJNI.js. It retrieves a
// TiledImageLoader from the closet and without this, sometimes
// TiledImageLoaded has not been loaded yet.
import TiledImageLoader from './resources/TiledImageLoader';
TiledImageLoader; // make the build happy
typeMap.addClassToModuleMap('commons::DispatchBridge', DispatchBridge);
typeMap.addClassToModuleMap('commons::EventDispatcher', EventDispatcher);
function _createRuntime() {
    if (isInitialized()) {
        // barf this should never happen
        return;
        //TODO: should this throw an error instead?
    }
    try {
        var RuntimeConfiguration = moduleLookupAsDefault('commons::RuntimeConfiguration', RuntimeConfigurationModule);
        var runtimeConfig = new RuntimeConfiguration();
        runtimeConfig.setPathToInstallDirectory(getRelativeAssetPath());
        runtimeConfig.setLocale(getLocale());
        runtimeConfig.setFormatterLocale(getFormatLocale());
        runtimeConfig.setSupportsMSAA(false);
        runtimeConfig.setSupportsAsyncNetworking(true);
        runtimeConfig.setSupportsThreads(false);
        runtimeConfig.setHasRunLoop(true);
        runtimeConfig.setDefaultImageDataPolicies(ImageDataPolicy.ACQUIRE_AS_TEXTURE_ONLY);
        runtimeConfig.setDpi(96.0);
        runtimeConfig.setEnableTraceLogging(TraceUtil.traceEnabled);
        // TODO: once ltjsUtil has these functions
        console.log('LTJS: getFormatLocale', getFormatLocale());
        console.log('LTJS: getLocale', getLocale());
        //
        // Setup global style default
        //
        // TODO: finish implementation
        var Style = moduleLookupAsDefault('commons::Style', StyleModule);
        Style.setDefaultGlobalStyleType(BuiltInStyles.NONE);
        // reduce synchronous requests by specifying a log config
        // IE keeps us from using template literals...
        var logConfig = [];
        logConfig.push('[GENERAL]');
        logConfig.push('logfile = Portable.log');
        var logLevel = 'loglevel = ';
        var logLevelOverride = getUriParameter('clogLogLevel');
        if (logLevelOverride) {
            logLevel += logLevelOverride;
        }
        else {
            logLevel += 'WARNING';
        }
        logConfig.push(logLevel);
        logConfig.push('[DEBUG]');
        logConfig.push('output = CONSOLE');
        logConfig.push('[INFO]');
        logConfig.push('output = CONSOLE');
        logConfig.push('[WARNING]');
        logConfig.push('output = CONSOLE');
        logConfig.push('[ERROR]');
        logConfig.push('output = CONSOLE');
        logConfig.push('[SASNOTE]\noutput = LOG_FILE\n[SASWARNING]\noutput = LOG_FILE');
        logConfig.push('[STIMER]');
        logConfig.push('output = LOG_FILE');
        runtimeConfig.setLogConfig(logConfig.join('\n'));
        Runtime.initialize(runtimeConfig);
        // Setup a timer to update the portable timers every 1 second.
        var ResourceManager_1 = moduleLookupAsDefault('commons::ResourceManager', ResourceManagerModule);
        setInterval(function () {
            ResourceManager_1.updateTimers();
        }, 1000);
        console.log('*******************************');
        console.log('LTJS PLATFORM INITIALIZATION SUCCESS');
        console.log('*******************************');
    }
    catch (e) {
        console.error('ERROR!!! LTJS PLATFORM INITIALIZATION FAILURE', e);
    }
    initialize();
}
function _initializePlatform() {
    ltjsModule.runtime.initializedTypemap();
    // This should include all of the js dependencies we need to use in ltjs.
    ltjsModule.deps = {
        // need to use this version in JNI for hybrid apps
        isOpenUI: !!sas.ltjs.isOpenUI,
        ClosetUtil: ltjsModule,
        TextAlignment: TextAlignment,
        WrappableCloset: WrappableCloset,
        HttpVerb: HttpVerb,
        NetworkDataEvent: moduleLookupAsDefault('commons::NetworkDataEvent', NetworkDataEventModule),
        NetworkImageEvent: moduleLookupAsDefault('commons::NetworkImageEvent', NetworkImageEventModule),
        RenderMode: RenderMode,
        ViewManager: moduleLookupAsDefault('commons::ViewManager', ViewManagerModule),
        PortableEvent: moduleLookupAsDefault('commons::PortableEvent', PortableEventModule),
        TextUtil: TextUtil,
        TraceUtil: TraceUtil,
        ltjsUtil: {
            getResourceURL: getResourceURL,
            getUriParameter: getUriParameter,
            warn: warn,
            ajax: ajax,
            getImage: getImage,
            getSASAjaxConfig: getSASAjaxConfig,
            getBrowserName: getBrowserName,
            BROWSER: BROWSER,
        },
        updateVisualizationSizes: updateVisualizationSizes,
        TriState: TriState,
    };
    var bundlePathTemplate = getRelativeAssetPath() + '{PACKAGE}/NLS/{LOCALE}/{BUNDLE}.properties';
    var ResourceManager = moduleLookupAsDefault('commons::ResourceManager', ResourceManagerModule);
    ResourceManager.setBundlePathTemplate(bundlePathTemplate);
    for (var _i = 0, _a = getRegisteredPortablePackages(); _i < _a.length; _i++) {
        var RegisteredPackage = _a[_i];
        RegisteredPackage.instance();
    }
    // ICUPackage initializes ICUFacility during the instance() call above.
    // Use the built-in collators provided by BrowserFacility instead if this flag is set.
    if (sas.ltjs.useBrowserCollation) {
        ResourceManager.setUnicodeFacility(new BrowserFacility());
    }
    _createRuntime();
}
/**************************************************************************/
/*                      Setup ltjs runtime                                */
/**************************************************************************/
/**
 * Set up the ltjs runtime.
 * May no-op in mixed environments if sas.ltjs.loaderRuntime is set.
 */
export function setupLtjsRuntime() {
    if (!currentRuntimeIsLoaderRuntime()) {
        return;
    }
    loadScript(getRegisteredModules());
    ltjsModule.onRuntimeInitialized = _initializePlatform;
    loadNLSProperties();
    // A dependency is added in post.js to ensure that ltjsRuntime.js loaded before the platform is initialized.
    if (ltjsModule.removeBlockingDependency) {
        ltjsModule.removeBlockingDependency('ltjsRuntimeInitialization');
    }
    ltjsModule.ltjsRuntimeInitialized = true;
    // clean up some leaks that IE is unable to take care of when the iframe goes down.
    if (!sas.ltjs.node) {
        window.addEventListener('unload', function () {
            // keep the thread manager and operation manager from using a setTimeout
            ltjsModule.setIsShuttingDown(true);
            try {
                purge(window.document);
            }
            catch (e) { }
        });
    }
}
